import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

import { propsFilter } from '@utils/propsFilter';

export const sxStyles = {
  schoolInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  infoItemDivider: {
    margin: '0 1rem',
    borderRight: `1px solid ${coreThemeColors.grey[300]}`,
  },
  infoItemTitle: {
    marginRight: '4px',
  },
  infoItemValue: (theme: Theme) => ({
    color: theme.palette.grey['700'],
    lineHeight: '1.5rem',
  }),
};

export const StyledHeaderWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1rem 2.5rem',
  width: '100%',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '1rem',
  },
}));

export const StyledProgressWrap = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginRight: '3rem',
  textAlign: 'center',
}));

export const StyledInfoSection = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '1rem',
  },
}));

export const StyledInfoItemsWrap = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '1rem',

  [theme.breakpoints.down('xs')]: {
    gap: '1rem 0',
  },
}));

export const StyledInfoItemWrap = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  '& > div:first-of-type': {
    display: 'flex',
    marginRight: '0.5rem',
  },
}));

export const StyledToggle = styled('div', {
  shouldForwardProp: propsFilter(['isOpen']),
})<{ isOpen?: boolean }>(({ isOpen, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  borderRadius: '40px',

  '&:hover': {
    cursor: 'pointer',
    background: theme.palette.grey[100],
  },

  '& > svg:first-of-type': {
    fill: theme.palette.grey['600'],
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));
